// import landingSurveyData1 from './quiz-fixed';
// import landingSurveyData1Duration from './landingSurveyData1Duration';

// export const LANDING_QUIZ_JSON = [{ landingSurveyData1 }];
// export const LANDING_QUIZ_DURATION_JSON = [{ landingSurveyData1Duration }];

export const LANDING_QUIZ_JSON = [{}];
export const LANDING_QUIZ_DURATION_JSON = [{}];
